export default __webpack_public_path__ + "static/lockup-first-gamers-rev-pos-sizzles-96f73fcb653b315eef74a1f99a97e384.png";